// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './TextCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * Text cell component for table display
 * @param {object} props
 * @param {any} props.value - Cell value to display
 * @param {string} [props.className] - Additional CSS classes
 * @param {Align} [props.align] - Text alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @param {boolean} [props.bold] - Text in bold
 * @param {boolean} [props.italic] - Text in italic
 * @param {boolean} [props.strikeThrough] - Text with strike-through
 * @param {boolean} [props.underline] - Text underlined
 * @returns {JSX.Element}
 */
function TextCell({
  value,
  className = '',
  align = 'left',
  verticalAlign = 'middle',
  bold = false,
  italic = false,
  strikeThrough = false,
  underline = false,
}) {
  return (
    <div
      className={cn([
        styles['text-cell'],
        className,
        bold && commonStyles['cell-bold'],
        italic && commonStyles['cell-italic'],
        strikeThrough && commonStyles['cell-strike-through'],
        underline && commonStyles['cell-underline'],
        align && commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <span
        className={cn([
          styles['text-cell-value'],
          align === 'right' && commonStyles['cell-crop-start'],
        ])}
      >
        {align === 'right' ? <bdi dir="ltr">{value || ''}</bdi> : (value || '')}
      </span>
    </div>
  );
}

export default TextCell;
